<template>
  <button 
    class="base-button"
    :class="{ 
      'variant-outline': variant === 'outline',
      'variant-solid': variant === 'solid'
    }"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

defineProps<{
  variant?: 'outline' | 'solid'
}>()

defineEmits(['click'])
</script>

<script lang="ts">
export default {
  name: 'BaseButton'
}
</script>

<style scoped>
.base-button {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
}

.variant-outline {
  background: transparent;
  border: 2px solid var(--bg-danger);
  color: var(--text-white);
}

.variant-outline:hover {
  background: rgba(255, 51, 21, 0.1);
}

.variant-solid {
  background: var(--bg-danger);
  border: none;
  color: var(--text-white);
}

.variant-solid:hover {
  background: var(--bg-danger);
}
</style>
